import { Either } from "src/base/Either"
import { Failure } from "src/base/Failure"
import { UseCase } from "src/base/UseCase"
import { IMedicalRecord } from "../../data/models/medicalRecord"
import { IMedicalRecordRepository } from "../../data/repositories/medicalRecordRepository"

export class AddMedicalRecord extends UseCase<AddMedicalRecordParams, void>{
    private repository: IMedicalRecordRepository
    constructor(repository: IMedicalRecordRepository) {
        super()
        this.repository = repository
    }

    call(params: AddMedicalRecordParams): Promise<Either<Failure, void>> {
        return this.repository.addNewMedicalRecord(params.medicalRecord)
    }

}

export class AddMedicalRecordParams {
    medicalRecord: IMedicalRecord
    constructor(medicalRecord: IMedicalRecord) {
        this.medicalRecord = medicalRecord
    }
}